import React from 'react';
import { connect } from 'react-redux';
import { handleAPIProvidedErrorMessage } from '../../../misc/handleAPIProvidedErrorMessage';
import Button from '../../elements/Button/Button';
import { dialogAlert } from '../../elements/Dialog/dialogs';
import Input from '../../elements/forms/Input';
import LeftTabbedGrayHeader from '../../elements/headers/LeftTabbedGrayHeader';
import Scrollable from '../../elements/Scrollable';
import TopBar from '../../elements/TopBar/TopBar';
import Screen from '../Screen';

class MyProfileScreen_Email extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            confirmation: '',
        };
    }
    render() {
        var { i18n, user } = this.props,
            header = (
                <>
                    <TopBar returnURL=".."></TopBar>
                    <hr />
                </>
            );

        return (
            <Screen header={header}>
                <Scrollable>
                    <form onSubmit={this.handleSubmit.bind(this)}>
                        <LeftTabbedGrayHeader>
                            {i18n['label.change.email']}
                        </LeftTabbedGrayHeader>
                        <br />
                        <br />
                        <div className="indent content">
                            <Input
                                type="email"
                                label={i18n['label.changeemail.previousemail']}
                                readOnly
                                value={user.email}
                                onChange={() => {}}
                            />
                            <Input
                                type="email"
                                label={i18n['label.changeemail.newemail']}
                                value={this.state.email}
                                onChange={this.handleChange.bind(this, 'email')}
                            />
                            <Input
                                type="email"
                                label={i18n['label.changeemail.confirmemail']}
                                value={this.state.confirmation}
                                onChange={this.handleChange.bind(
                                    this,
                                    'confirmation'
                                )}
                            />
                        </div>
                        <br />
                        <div className="content">
                            <Button type="submit" primary  >
                                {i18n['label.editprofile.store']}
                            </Button>
                        </div>
                    </form>
                </Scrollable>
            </Screen>
        );
    }
    handleChange(field, value) {
        this.setState({ [field]: value });
    }
    async handleSubmit(e) {
        e.stopPropagation();
        e.preventDefault();

        var { i18n, user } = this.props;
        var email = this.state.email.trim();
        var confirmation = this.state.confirmation.trim();

        if (!email.length | !confirmation.length) {
            await dialogAlert(i18n['message.allfieldsrequired']);
        } else if (email != confirmation) {
            await dialogAlert(i18n["message.confirmemaildoesn'tmatch"]);
        } else {
            app.api.users
                .updateUserProfile(this.props.user.id, { email })
                .then(
                    async function (user) {
                        await dialogAlert(
                            this.props.i18n['msg.message.upload.profile']
                        );
                        app.history.push('..');
                    }.bind(this)
                )
                .catch(handleAPIProvidedErrorMessage);
        }
    }
}

export default connect(function (state, props) {
    return { i18n: state.i18n.translations, user: state.session.user };
})(MyProfileScreen_Email);
